import { render, staticRenderFns } from "./ChatDateSeparator.vue?vue&type=template&id=b591d112&"
import script from "./ChatDateSeparator.vue?vue&type=script&setup=true&lang=js&"
export * from "./ChatDateSeparator.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports